"use client";

import { darken, useComputedColorScheme, useMantineTheme } from "@mantine/core";
import WaveBanner from "../../../components/footer/components/WaveBanner";
import EverythingYouNeedSection from "../../components/EverythingYouNeedSection";
import MoreThanResourceSection from "../../components/MoreThanResourceSection";
import PageSection from "../../components/PageSection";
import PrimaryCtaButton from "../../components/PrimaryCtaButton";
import SectionHeader from "../../components/SectionHeader";
import FaqModule from "../about/components/faq/FaqModule";

export default function StudentLayout() {
  const theme = useMantineTheme();
  const colorScheme = useComputedColorScheme("light");

  return (
    <main>
      {/* 1. Everything you need to succeed */}
      <EverythingYouNeedSection
        firstSection={true}
        title="Everything You Need For A 7."
        subTitle="From videos and notes to flashcards, questions and mock exams—organised by topic so you always know what to revise next."
      />
      <WaveBanner
        colors={{
          light: theme.colors.darkblue[9],
          dark: darken(theme.colors.darkblue[9], 0.3),
        }}
        bgColor={
          colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
        }
      />

      {/* 2. More than just a resource site */}
      <MoreThanResourceSection
        title="Track Your Performance."
        subTitle="Advanced analytics track your progress across all resources. Compare your performance to other users, or IB exam results."
      />
      <WaveBanner
        colors={{ light: theme.colors.gray[0], dark: theme.colors.dark[8] }}
        bgColor={theme.colors.darkblue[9]}
      />
      {/* 3. Final CTA – free trial for students */}
      <PageSection variant="darkBottom" minHeight={false}>
        <SectionHeader
          title="7 Days Completely Free."
          subTitle="No payment details required. Use your trial to show your parents the power of Tiber."
          align="center"
          needsLightTitle={true}
        />
        <PrimaryCtaButton href="/register">
          Start your free 7-day trial
        </PrimaryCtaButton>
      </PageSection>
      <WaveBanner
        colors={{ light: theme.colors.blue[7], dark: theme.colors.darkblue[5] }}
        bgColor={
          colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
        }
      />

      {/* 4. FAQ – key questions students and parents ask */}
      <PageSection variant="light">
        <SectionHeader
          title="Questions You Might Have."
          subTitle="Get clear answers you can share with your parents."
          align="center"
        />
        <FaqModule />
      </PageSection>
      <WaveBanner
        colors={{ light: theme.colors.gray[0], dark: theme.colors.dark[8] }}
        bgColor={
          colorScheme === "dark"
            ? theme.colors.dark[9]
            : darken(theme.colors.darkblue[9], 0.2)
        }
      />
    </main>
  );
}
